import { useMemo, useState } from 'react';

import { createContexts } from '@/js/libs/create-contexts/index.ts';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { countColumns } from './countColumns.ts';

interface ColumnMeta {
  columns: string;
  hasDnd: boolean;
  hasCheckbox: boolean;
  hasAction: boolean;
  fluid: boolean;
}

const DEFAULT_COLUMN_META: ColumnMeta = { columns: '', hasDnd: false, hasCheckbox: false, hasAction: false, fluid: false };

export const { useTableContext } = createContexts({
  Table({ inner, compact }: { inner: boolean; compact?: boolean }) {
    const [meta, setMeta] = useState<ColumnMeta>(DEFAULT_COLUMN_META);
    const columnCount = useMemo(() => (meta.columns ? countColumns(meta.columns) : 0), [meta.columns]);

    const registerColumns = useCallbackRef((next: ColumnMeta) =>
      setMeta((prev) =>
        prev.columns === next.columns &&
        prev.hasDnd === next.hasDnd &&
        prev.hasCheckbox === next.hasCheckbox &&
        prev.hasAction === next.hasAction &&
        prev.fluid === next.fluid
          ? prev
          : next,
      ),
    );

    return {
      inner,
      compact: !!compact,
      columns: meta.columns,
      columnCount,
      registerColumns,
      hasDnd: meta.hasDnd,
      hasCheckbox: meta.hasCheckbox,
      hasAction: meta.hasAction,
      fluid: meta.fluid,
    };
  },
});
